/**
 * Есть ли в сырой сетке хоть одно значение.
 *
 * Пустая сетка — не ошибка запроса: за выбранную дату в этом кадре данных может
 * не быть вовсе (2026-08-08: SST за 09.08 лежала только по полосе 44…60° с.ш.,
 * 138…163° в.д., и в Беринговом инструменты молчали). Молчать об этом нельзя —
 * человек видит включённый тумблер и чистую карту.
 */
export interface RawGrid {
  values?: (number | null)[][] | null
}

export function gridHasData(grid: RawGrid | null | undefined): boolean {
  const rows = grid?.values
  if (!rows?.length) return false
  return rows.some(row => row?.some(v => v != null))
}

/**
 * Данные в кадре есть, но закрывают его не целиком.
 *
 * Прод, 2026-08-12 (кадр 149…185° в.д., 12 августа): `sst` лежала до 162,67° в.д.
 * — кромки регулярной предзагрузки. Изотермы обрывались по прямой, а кабинет
 * молчал: `gridHasData` истинен от ОДНОЙ непустой ячейки.
 *
 * Охват берём у сервера (`/data/availability` → тот же критерий 4 краёв, что и у
 * докачки), а не считаем по доле NULL в сетке: суша тоже NULL, и любой берег в
 * кадре давал бы ложную тревогу. `undefined` — ручка не ответила: молчим.
 */
export function gridIsPartial(
  grid: RawGrid | null | undefined,
  covered: boolean | undefined,
): boolean {
  return covered === false && gridHasData(grid)
}
